module.exports = __webpack_public_path__ + "img/ru_Ecran 4.aa10bbb5.png";